import { SortInput } from 'components/Table'
import { SupplyChainSortBy } from './types'

export const DEFAULT_SORT: SortInput<SupplyChainSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: SupplyChainSortBy[] = ['name', 'asi', 'defaultSid', 'updatedAt']
